import { render, staticRenderFns } from "./DetallesLeads.vue?vue&type=template&id=6d285941"
import script from "./DetallesLeads.vue?vue&type=script&lang=js"
export * from "./DetallesLeads.vue?vue&type=script&lang=js"
import style0 from "./DetallesLeads.vue?vue&type=style&index=0&id=6d285941&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports